import { render, staticRenderFns } from "./NewStockDialog.vue?vue&type=template&id=04d52f1f&scoped=true"
import script from "./NewStockDialog.vue?vue&type=script&lang=js"
export * from "./NewStockDialog.vue?vue&type=script&lang=js"
import style0 from "./NewStockDialog.vue?vue&type=style&index=0&id=04d52f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d52f1f",
  null
  
)

export default component.exports